const Login = () => {
    window.location.href = `${process.env.REACT_APP_COGNITO_DOMAIN}&redirect_uri=${process.env.REACT_APP_COGNITO_REDIRECT}`;
    return null;
};

export default Login;
